import { render } from "./Login.vue?vue&type=template&id=59637cdd&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=59637cdd&scoped=true&lang=css"

import exportComponent from "C:\\Users\\HP\\Desktop\\Vuejsproject\\final\\yajobici-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59637cdd"]])

export default __exports__